<h1 mat-dialog-title oneDialogTitle>Filter</h1>
<div mat-dialog-content oneDialogContent class="filter-overlay-container">
  <div class="fd-filter">
    <label for="date-sent" class="fd-label">Date sent</label>
    <mat-form-field oneFormField appearance="fill" class="fd-formField">
      <mat-label *ngIf="!dateSent_startDate.value">Select date range</mat-label>
      <mat-date-range-input [rangePicker]="DateSentpicker" matInput>
        <input [formControl]="dateSent_startDate" placeholder="Start date" matStartDate (focus)="DateSentpicker.open()" data-test-id="basic-datepicker-component.input" />
        <input [formControl]="dateSent_endDate" placeholder="End date" matEndDate (focus)="DateSentpicker.open()" data-test-id="basic-datepicker-component.input" />
      </mat-date-range-input>
      <button mat-icon-button one-icon-button matSuffix *ngIf="!dateSent_startDate.value">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.date-icon" class="fd-clearIcon">date</mat-icon>
      </button>
      <button *ngIf="dateSent_startDate.value" mat-icon-button one-icon-button matSuffix (click)="clearDSform($event)">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.clear-icon" class="fd-clearIcon">clear </mat-icon>
      </button>
      <mat-date-range-picker #DateSentpicker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="fd-filter">
    <label for="date-delivered" class="fd-label">Date delivered </label>
    <mat-form-field oneFormField appearance="fill" class="fd-formField">
      <mat-label *ngIf="!dateDelivered_startDate.value">Select date range</mat-label>
      <mat-date-range-input [rangePicker]="DateDeliveredpicker" matInput>
        <input [formControl]="dateDelivered_startDate" placeholder="Start date" matStartDate (focus)="DateDeliveredpicker.open()" data-test-id="basic-datepicker-component.input" />
        <input [formControl]="dateDelivered_endDate" placeholder="End date" matEndDate (focus)="DateDeliveredpicker.open()" data-test-id="basic-datepicker-component.input" />
      </mat-date-range-input>
      <button mat-icon-button one-icon-button matSuffix *ngIf="!dateDelivered_startDate.value">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.date-icon" class="fd-clearIcon">date</mat-icon>
      </button>
      <button *ngIf="dateDelivered_startDate.value" mat-icon-button one-icon-button matSuffix (click)="clearDDform($event)">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.clear-icon" class="fd-clearIcon">clear </mat-icon>
      </button>
      <mat-date-range-picker #DateDeliveredpicker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="fd-filter">
    <label for="date-read" class="fd-label">Date read </label>
    <mat-form-field oneFormField appearance="fill" class="fd-formField">
      <mat-label *ngIf="!dateRead_startDate.value">Select date range</mat-label>
      <mat-date-range-input [rangePicker]="DateReadpicker" matInput>
        <input [formControl]="dateRead_startDate" matStartDate (focus)="DateReadpicker.open()" data-test-id="basic-datepicker-component.input" />
        <input [formControl]="dateRead_endDate" matEndDate (focus)="DateReadpicker.open()" data-test-id="basic-datepicker-component.input" />
      </mat-date-range-input>
      <button mat-icon-button one-icon-button matSuffix *ngIf="!dateRead_startDate.value">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.date-icon" class="fd-clearIcon">date</mat-icon>
      </button>
      <button *ngIf="dateRead_startDate.value" mat-icon-button one-icon-button matSuffix (click)="clearDRform($event)">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.clear-icon" class="fd-clearIcon">clear </mat-icon>
      </button>
      <mat-date-range-picker #DateReadpicker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="fd-filter">
    <label for="feedback-received" class="fd-label">Feedback received </label>
    <mat-form-field oneFormField appearance="fill" class="fd-formField">
      <mat-label *ngIf="!feedbackReceived_startdate.value">Select date range</mat-label>
      <mat-date-range-input [rangePicker]="Feedbackreceivedpicker" matInput>
        <input [formControl]="feedbackReceived_startdate" matStartDate (focus)="Feedbackreceivedpicker.open()" data-test-id="basic-datepicker-component.input" />
        <input [formControl]="feedbackReceived_endDate" matEndDate (focus)="Feedbackreceivedpicker.open()" data-test-id="basic-datepicker-component.input" />
      </mat-date-range-input>
      <button mat-icon-button one-icon-button matSuffix *ngIf="!feedbackReceived_startdate.value">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.date-icon" class="fd-clearIcon">date</mat-icon>
      </button>
      <button *ngIf="feedbackReceived_startdate.value" mat-icon-button one-icon-button matSuffix (click)="clearFRform($event)">
        <mat-icon matSuffix data-test-id="basic-datepicker-component.clear-icon" class="fd-clearIcon">clear </mat-icon>
      </button>
      <mat-date-range-picker #Feedbackreceivedpicker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="fd-filter">
    <label for="status" class="fd-label">Status </label>
    <one-filtering-chip class="fd-status" [list]="statusList" [placeholder]="statusPlaceholder" [formControl]="statusFormControl" [width]="width"></one-filtering-chip>
  </div>
</div>
<div mat-dialog-actions oneDialogActions class="filter-overlay-action">
  <div class="ad-button-row">
    <div class="ad-button-box">
      <button mat-stroked-button one-secondary-button (click)="clearForm()">
        Clear all
      </button>
      <button color="primary" mat-flat-button class="fd-apply" (click)="applyFilter()" [mat-dialog-close]="false">Apply</button>
      <button mat-stroked-button one-secondary-button class="fd-cancel" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</div>